import React from "react";
import { AppPrintIcon } from "../../Icon/AppPrintIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const PrintButton = (props: IAppButtonProps) => (
    <AppButton
        variant="text"
        color="inherit"
        startIcon={<AppPrintIcon />}
        {...props}
    >
        {props.children}
    </AppButton>
);
